// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requestRmaCheckBoxConfirmationStyles } from "@guestsupply/App/Widgets/RequestRma/RequestRmaCheckBoxConfirmation";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

requestRmaCheckBoxConfirmationStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        background: ${color("common.ui2")};
        padding: 8px 9px;
        border-radius: 4px;
        border: 1px solid ${color("common.border")};
    `,
};

requestRmaCheckBoxConfirmationStyles.titleText = {
    size: 14,
    lineHeight: "22px",
};

requestRmaCheckBoxConfirmationStyles.buttonsWrapper = {
    css: css`
        display: flex;
        gap: 16px;
    `,
};

requestRmaCheckBoxConfirmationStyles.sendButton = {
    css: css`
        flex: 2;
    `,
};

requestRmaCheckBoxConfirmationStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        flex: 1;
    `,
};
